module.exports = __webpack_public_path__ + "assets/22d68a638539b65014e120048fae3640.mp4";